<template>
  <footer class="front-footer">
    <div class="front-footer-go-up-container">
      <button
         title="Go back to the top of the page"
         v-if="isGoUpNeeded"
         @click.prevent="goUpAction()"
         class="go-up-button"></button>
    </div>
    <!-- .front-footer-top -->
    <div class="front-footer-top">
      <!-- .myContainer -->
      <div class="myContainer">
        <!-- .front-footer-top__inner -->
        <div class="front-footer-top__inner">
          <div class="front-footer-supported-by">
            <!--<span class="footer-section-head" v-if="getIsLoggedIn && getUserRole !== 'gm'">Useful links</span>
            <span class="footer-section-head" v-else>Supported by</span>
            <ul class="footer-section-links" v-if="getIsLoggedIn && getUserRole !== 'gm'">
              <li>
                <router-link :to="{ name: 'user-app'}" title="Clear Assured dashboard">Dashboard</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'about'}" title="About">About</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'download-brochure'}" title="Download brochure">Download brochure</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'contact'}" title="Contact">Contact</router-link>
              </li>
            </ul> -->
            <template v-if="sponsors.length">
              <span class="footer-section-head" v-if="sponsorsLogo">{{ sponsorsLogo }}</span>
              <span class="footer-section-head" v-else>In association with</span>
              <div class="industry-logos">
                <template v-for="(row, index) in sponsors">
                  <template v-if="row.url">
                    <a :href="row.url" target="_blank" class="industry-logos__item"
                       :class="'industry-logos__item__' + (index + 1)" v-if="index < 10">
                      <img :src="getImageFullPath(row.logo)" v-bind:alt="row.altImage" />
                    </a>
                  </template>
                  <template v-else>
                    <a href="#" class="industry-logos__item"
                       @click.prevent=""
                       :class="'industry-logos__item__' + (index + 1)" v-if="index < 10">
                      <img :src="getImageFullPath(row.logo)" v-bind:alt="row.altImage" />
                    </a>
                  </template>
                </template>
              </div>
            </template>
            <template v-else>
              <span class="footer-section-head" v-if="this.footerData.logosLabel">{{ this.footerData.logosLabel }}</span>
              <span class="footer-section-head" v-else>Sponsors</span>

              <div class="industry-logos">
                <template v-for="(row, index) in this.footerData.logos">
                  <template v-if="row.url">
                    <a :href="row.url"
                       style="background-color: transparent;"
                       :class="'industry-logos__item__' + (index + 1)" v-if="index < 10"
                       target="_blank"
                       :title="row.alt"
                       class="industry-logos__item">
                      <img :src="getImageFullPath(getHighImage(row))" v-bind:alt="row.altImage" />
                    </a>
                  </template>
                  <template v-else>
                    <a :href="row.url"
                       style="background-color: transparent;"
                       :title="row.alt"
                       @click.prevent=""
                       :class="'industry-logos__item__' + (index + 1)" v-if="index < 10"
                       class="industry-logos__item">
                      <img :src="getImageFullPath(getHighImage(row))" v-bind:alt="row.altImage" />
                    </a>
                  </template>
                </template>
              </div>
            </template>
          </div>
          <!-- .front-footer-info -->
          <div class="front-footer-info">
            <span class="footer-section-head" v-if="this.footerData.addressLabel">{{ this.footerData.addressLabel }}</span>
            <span class="footer-section-head" v-else>Address</span>
            <p v-html="this.footerData.address"></p>
          </div>
          <!-- END:.front-footer-info -->
          <!-- .front-footer-social -->
          <div class="front-footer-social">
            <span class="footer-section-head" v-if="this.footerData.socialLabel">{{ this.footerData.socialLabel }}</span>
            <span class="footer-section-head" v-else>Join us</span>
            <ul class="front-footer-social-list">
              <li class="front-footer-social-list__item" v-for="item in this.footerData.social">
                <a :href="item.url"
                   target="_blank"
                   :title="item.altImage"
                   v-bind:aria-label="item.altImage"
                   v-bind:style="{ backgroundImage: getImage(getHighImage(item)) }"
                   class="front-footer-social-list__link"></a>
              </li>
            </ul>
          </div>
          <div class="clearfix"></div>
          <!-- END:.front-footer-social -->
        </div>
        <!-- END:.front-footer-top__inner -->
      </div>
      <!-- END:.myContainer -->
    </div>
    <!-- END:.front-footer-top -->

    <!-- .front-footer-links -->
    <div class="front-footer-links">
      <!-- .myContainer -->
      <div class="myContainer">
        <!-- .front-footer-links__inner -->
        <div class="front-footer-links__inner">
          <!-- front-footer-links-list -->
          <ul class="front-footer-links-list">
            <li class="front-footer-links-list__item" v-for="item in this.footerData.menu">
              <a :href="item.url"
                 :title="item.alt"
                 class="front-footer-links-list__link">{{ item.title }}</a>
            </li>
          </ul>
          <!-- END:front-footer-links-list -->
        </div>
        <!-- END:.front-footer-links__inner -->
      </div>
      <!-- END:.myContainer -->
    </div>
  </footer>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'user-header',
  data () {
    return {
      sponsors: [],
      sponsorsLogo: null,
      footerData: [],
      isGoUpNeeded: false,
      company: null
  }
  },
  computed: {
    ...mapGetters([
      'bgColorSpOp',
      'getIsLoggedIn',
      'color',
      'getUserRole',
      'selectedHightCont'
    ])
  },
  watch: {
    selectedHightCont() {
      this.$forceUpdate()
    }
  },
  methods: {
    tawkTo (user) {

      let body = {
        email: user.email
      }
      this.$http.post(api.URLS.tawkHash, body, api.headersAuthSettings)
        .then((res) => {

          let hash = res.body.hash;

          let s1=document.createElement('script')
          s1.async=true;
          s1.id = 'tawkScript'
          s1.src='https://embed.tawk.to/59b658fec28eca75e461f521/' + (localStorage.selectedHightCont == 1 ? '1btu6qlga' : 'default')
          s1.charset='UTF-8';
          s1.setAttribute('crossorigin','*');

          document.getElementsByTagName("head")[0].appendChild(s1)

          let s2=document.createElement('script')

          s2.innerHTML = "var Tawk_API=Tawk_API||{};\n" +
            "var Tawk_LoadStart=new Date();\n" +
            "Tawk_API.onLoad = function(){\n" +
            "Tawk_API.setAttributes({\n" +
              " 'name' : '" + user.first_name + " " + user.last_name + (user.company ?  (' (' + user.company.name + ')') : '') + "',\n" +
              " 'email': '" + user.email + "',\n" +
              " 'hash' : '" + hash + "'\n" +
            "}, function (error) {});\n" +
          "};";

          document.getElementsByTagName("head")[0].appendChild(s2)

        })
        .catch((err) => {
          console.log(err)
        })
    },
    getFooterData () {
      let self = this
      let body = {
        slug: 'footer'
      }
      let body2 = {}
      let industryId = localStorage.getItem('userIndustry') ? localStorage.getItem('userIndustry') : 1
      if (this.company !== null) {
        body2.company_url = this.company
      }
      this.$http.post(api.URLS.staticpage + '/footer', body, api.headersAuthSettings).then(function (data) {
        let pageData = JSON.parse(data.data.body)
        pageData.address = pageData.address.replace(/\r\n|\r|\n/g,"<br />")
        self.footerData = pageData
      })
      this.$http.post(api.URLS.sponsorsByLanding + '/' + industryId, {}, api.headersAuthSettings).then(function (data) {
        if (data.body.hasLanding === true && data.body.sponsors && data.body.logosLabel) {
          self.sponsors = data.body.sponsors
          self.sponsorsLogo = data.body.logosLabel
        } else {
          this.$http.post(api.URLS.sponsorsByLanding + '/1', {}, api.headersAuthSettings).then(function (data2) {
            if (data2.body.hasLanding === true) {
              self.sponsors = data2.body.sponsors
              self.sponsorsLogo = data2.body.logosLabel
            }
          })
        }
      })
    },
    getUserData () {
      this.$http.put(api.URLS.profile, {}, api.headersAuthSettings).then((res) => {
        if (res.body.company && res.body.company.sees_chat) {
          this.tawkTo(res.body)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getImagePath () {
      return api.serverURL + '/uploads/images/content/'
    },
    isBase64 (payload) {
      return payload.indexOf('data:') !== -1
    },
    getImage (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
    },
    getImageFullPath (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload
    },
    getHighImage (item) {
      return this.selectedHightCont === 1 ? item.imageHigh : item.image
    },
    goUpAction () {
      let element = document.getElementsByTagName('HEADER')
      let h1 = document.getElementsByTagName('H1')
      element[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
      if (h1.length) {
        setTimeout(function () {
          h1[0].setAttribute('tabindex', '-1')
          h1[0].focus()
        }, 1000)
      }
    },
    goUpNeeded () {
      let documentHeight = document.documentElement.scrollHeight
      let windowHeight = window.innerHeight
      if (documentHeight > windowHeight + 500) {
        this.isGoUpNeeded = true
      } else {
        this.isGoUpNeeded = false
      }
    }
  },
  components: {
  },
  mounted () {
    this.getFooterData()
    if (this.getIsLoggedIn) {
      this.getUserData()
    }
  },
  created () {
    if (this.$route.query.company) {
      this.company = this.$route.query.company
    }
    document.addEventListener('scroll', this.goUpNeeded)
  },
  destroyed () {
    window.removeEventListener('scroll', this.goUpNeeded)
  }
}
</script>

<style src="@/assets/scss/main/common/footer.scss" lang="scss" scoped/>
<style>
  .wrapper{
    min-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// AppFooter.vue?7c451b36